import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, STATUS } from "../../../Constants";
import axios from "axios";
import { toast } from "react-toastify";


// For Get All User API 
const GetMessengersEndpoint = (args)=>`${DomainName}/page/messenger?accessToken=${args.userToken}&user_id=${args.userId}&page_id=${args.pageId}`;

export const getMessengersIDsAPI = createAsyncThunk('messengers/get' ,async(args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ; 

    try{
        const response = await axios.get(GetMessengersEndpoint(args) , {
            headers :{
                token : args.token
            }
        }) ; 
        return response.data.users
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Store State
const initialState = {
    users : [] , 
    status : STATUS.IDLE 
}

const MessengerSlice = createSlice({
    name :"messenger" ,
    initialState , 
    reducers :{

    }, 
    extraReducers : (builder)=>{
        builder

        // For Get All Messengers
        .addCase(getMessengersIDsAPI.fulfilled , (state , action)=>{
            state.users = action.payload ; 
            state.status = STATUS.SUCCESS;
        })
        .addCase(getMessengersIDsAPI.pending , (state )=>{
            state.status = STATUS.LOADDING ; 
        })
        .addCase(getMessengersIDsAPI.rejected ,(state)=>{
            state.status = STATUS.ERROR ; 
            toast.error("Something error with token")
        })
    }
})



export const getALlMessengers = state => state.MessengerSlice ;

export default MessengerSlice.reducer ; 
